import { ScrollArea } from '@/src/components/ui/scroll-area';
import { cn } from '@/src/utils';

interface PhonePreviewProps {
  children: React.ReactNode;
}

export default function PhonePreview({ children }: PhonePreviewProps) {
  return (
    <div className="relative w-full">
      <img
        src="/assets/images/img-phone-frame.png"
        width="100%"
        height="auto"
      />
      <article className="absolute left-0 right-0 top-[10%] h-[85%] overflow-hidden px-[3%]">
        <ScrollArea className="h-full w-full overflow-auto">
          {children}
        </ScrollArea>
      </article>
    </div>
  );
}

interface PhonePreviewHeaderProps {
  className?: string;
  children: React.ReactNode;
}

PhonePreview.Header = ({ children, className }: PhonePreviewHeaderProps) => {
  return (
    <header className={cn('p-[4%] pb-[2.5%]', className)}>{children}</header>
  );
};

interface PhonePreviewContentProps {
  className?: string;
  children: React.ReactNode;
  style?: React.CSSProperties;
}

PhonePreview.Content = ({
  children,
  className,
  style,
}: PhonePreviewContentProps) => {
  return (
    <div className={cn('p-[4%]', className)} style={style}>
      {children}
    </div>
  );
};
